import React, {useCallback} from "react";
import {useParams} from "react-router-dom";
import {useTypedSelector} from "../../../redux/Hooks/storeSelectors";
import {selectMapLayerIdByEntityName} from "../../../redux/selectors/selectors";
import EntityManagerCleaner from "../../../components/Entities/EntityManagerCleaner";
import EntityEditor from "../../../components/Entities/EntityEditor";
import {ScenarioEventsEntityName} from "../../../api/types/types";


const TransitEventEdit = () => {
    const entityName = ScenarioEventsEntityName.TransitEvent;
    const {transitEventId} = useParams<any>();
    const stopsLayerId = useTypedSelector((state) => selectMapLayerIdByEntityName(state, entityName));

    const onSaveFn = useCallback((entity: any) => {
        if (!transitEventId) {
            return `../${entity.id}/edit`;
        }
    }, [transitEventId]);

    const onDeleteFn = useCallback(() => '../../', []);

    return (
        <EntityManagerCleaner entityName={entityName}>
            <EntityEditor
                entityId={transitEventId!}
                entityName={entityName}
                layerId={stopsLayerId}
                presetProperty={'scenarioCasePreset'}
                getUrlOnSaveFn={onSaveFn}
                getUrlOnDeleteFn={onDeleteFn}
                showDeleteBtn={!!transitEventId}
            />
        </EntityManagerCleaner>
    )
}

export default TransitEventEdit;